import { useState } from "react";
import LeafletMap from "./LeafletMap";
import GlobeMap from "./GlobeMap";

export default function MapPage() {
    const [view, setView] = useState("map");

    return (
        <div style={{ height: "100%", width: "100%", position: "relative" }}>
            <button
                onClick={() => setView((v) => (v === "map" ? "globe" : "map"))}
                style={{
                    position: "absolute",
                    top: 10,
                    left: 10,
                    zIndex: 2000,
                    padding: "8px 16px",
                    backgroundColor: view === "globe" ? "#6b46c1" : "#4a3080",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontWeight: "bold",
                }}
            >
                {view === "map" ? "Globe View" : "Map View"}
            </button>
            {view === "map" ? <LeafletMap /> : <GlobeMap />}
        </div>
    );
}
